import moment from "moment/moment";

export const getDefaultDates = (data) => {
  const roundedUp = Math.ceil(moment().minute() / 15) * 15;

  const defaultPickupDate = data?.pickup_date
    ? moment(data.pickup_date).toDate()
    : moment().add(24, "hours").minute(roundedUp).second(0).toDate();

  const defaultDropOffDate = data?.dropoff_date
    ? moment(data.dropoff_date).toDate()
    : moment(defaultPickupDate).add(2, "days").toDate();

  return { defaultPickupDate, defaultDropOffDate };
};
